import type { ReactNode } from 'react';

import Alert, { AlertProps } from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import type { SxProps, Theme } from '@mui/material/styles';

interface AlertMessageProps {
  severity?: AlertProps['severity'];
  title?: string;
  children: ReactNode;
  icon?: ReactNode;
  sx?: SxProps<Theme>;
}

const defaultSx: SxProps<Theme> = {
  alignItems: 'flex-start',

  '& .MuiAlert-message': {
    width: '100%',
    color: 'text.primary',
    py: 0,
  },

  '& .MuiAlertTitle-root': {
    color: 'text.primary',
    fontWeight: 600,
  },

  '& .MuiTypography-root': {
    color: 'text.primary',
  },
};

const AlertMessage = ({
  severity = 'warning',
  title = '',
  children,
  icon = '',
  sx = {},
}: AlertMessageProps) => {
  return (
    <Alert
      severity={severity}
      icon={icon}
      sx={{ ...defaultSx, ...(sx as object) }}
    >
      {title && <AlertTitle>{title}</AlertTitle>}
      {children}
    </Alert>
  );
};

export default AlertMessage;
